import * as React from 'react';
// import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';
import 'dayjs/locale/nl';
import 'dayjs/locale/de';
import 'dayjs/locale/it';
import 'dayjs/locale/pt';
import Box from '@mui/material/Box';
// import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';

const locales = ['en', 'fr', 'es', 'nl', 'de', 'it', 'pt'];

export default function ResponsiveDateRangePicker(props) {
  const { selectedDates } = props;

  const [locale, setLocale] = React.useState(ENV.prefix_lang ? (ENV.prefix_lang).substr(0,2) : 'en');
  const [value, setValue] = React.useState([null, null]);

  React.useEffect(() => {
    let value = selectedDates.length ? selectedDates : [null, null];
    setValue(value);
  }, [selectedDates]);

  const selectLocale = (newLocale) => {
    setLocale(newLocale);
  };

  return (
    <>
      <ThemeProvider theme={backYouTheme}>
        <LocalizationProvider
          dateAdapter={AdapterDayjs} 
          adapterLocale={locale}
          localeText={{ start: 'Du', end: 'Au' }}
        >
          <DateRangePicker
            value={value}
            onChange={(newValue) => {
              setValue(newValue);
              props.parentFunction(newValue, 'date_custom');
            }}
            renderInput={(startProps, endProps) => { 
              startProps.inputProps = {
                ...startProps.inputProps,
                type: "text",
                inputMode: "numeric"
              };

              endProps.inputProps = {
                ...endProps.inputProps,
                type: "text",
                inputMode: "numeric"
              }

              return (
              <React.Fragment>
                <input className="form-control" ref={startProps.inputRef} {...startProps.inputProps} />
                <Box sx={{ mx: 1 }}><i className="fa-regular fa-arrow-right"></i></Box>
                <input className="form-control" ref={endProps.inputRef} {...endProps.inputProps} />
              </React.Fragment>
            )}}
          />
        </LocalizationProvider>   
      </ThemeProvider>      
    </>
  );
}